import { unininitializedState } from '../store'

import {
  HIGHLIGHT_TODO,
  // UNHIGHLIGHT_TODO,
  BEGIN_INITIALIZATION,
  END_INITIALIZATION,
  CLEAR_ALL,
  ADD_TODO_VIA_FIREBASE,
  MODIFY_TODO_VIA_FIREBASE,
  REMOVE_TODO_VIA_FIREBASE
} from '../actions/actionTypes'

function todos (state = {}, action) {
  if (state.todoItems === undefined) {
    switch (action.type) {
      case BEGIN_INITIALIZATION:
        return {
          todoItems: []
        }
      default:
        return state
    }
  }

  switch (action.type) {
    case END_INITIALIZATION:
      return {
        ...state,
        editIndex: -1,
        highlightIndex: -1
      }

    case ADD_TODO_VIA_FIREBASE:
      return addTodoViaFirebase(state, action)

    case MODIFY_TODO_VIA_FIREBASE:
      return modifyTodoViaFirebase(state, action)

    case REMOVE_TODO_VIA_FIREBASE:
      return removeTodoViaFirebase(state, action)

    case HIGHLIGHT_TODO:
      return highlightTodo(state, action)

    // case UNHIGHLIGHT_TODO:
    //   return cancelTodoHighlight(state/*, action */);

    case CLEAR_ALL:
      return clearTodos()

    default:
      return state
  }
}

function highlightTodo (state, action) {
  return {
    ...state,
    highlightIndex: action.index
  }
}

// function cancelTodoHighlight(state/*, action */){
//   return {
//     ...state,
//     highlightIndex: -1,
//   };
// }

function clearTodos (/* state, action */) {
  return unininitializedState.todos
}

function addTodoViaFirebase (state, action) {
  return {
    ...state,
    todoItems: [...state.todoItems, { ...action.todo }]
  }
}

function modifyTodoViaFirebase (state, action) {
  const index = state.todoItems.findIndex(todo => todo.id === action.todo.id)
  return index === -1
    ? state
    : {
      ...state,
      todoItems: [
        ...state.todoItems.slice(0, index),
        { ...state.todoItems[index], ...action.todo },
        ...state.todoItems.slice(index + 1)
      ],
      editIndex: -1
    }
}

function removeTodoViaFirebase (state, action) {
  const index = state.todoItems.findIndex(todo => todo.id === action.todo.id)
  return {
    ...state,
    todoItems: [
      ...state.todoItems.slice(0, index),
      ...state.todoItems.slice(index + 1)
    ]
  }
}

export default todos



// WEBPACK FOOTER //
// ./src/reducers/todos.js